import { create } from 'zustand';

// Top-level tool the user is working in.
// 'edit'    -> the PDF editor (default, original feature)
// 'compare' -> the PDF comparison tool
export const useApp = create((set) => ({
  appTool: 'edit',
  setAppTool: (appTool) => set({ appTool }),
}));
